import { Controller } from "@hotwired/stimulus"

export default class extends Controller<HTMLElement> {
  static values = {
    key: { type: String, default: "scroll_position" }
  }

  declare readonly keyValue: string

  connect(): void {
    this.restoreScrollPosition()
  }

  savePosition(): void {
    sessionStorage.setItem(this.keyValue, window.scrollY.toString())
  }

  restoreScrollPosition(): void {
    const savedPosition = sessionStorage.getItem(this.keyValue)
    if (savedPosition) {
      requestAnimationFrame(() => {
        window.scrollTo(0, parseInt(savedPosition, 10))
        // 복원 후 약간의 지연을 두고 삭제 (다른 페이지 거쳐 돌아올 때를 위해)
        setTimeout(() => {
          sessionStorage.removeItem(this.keyValue)
        }, 1000)
      })
    }
  }
}
